import { useNavigate } from 'react-router-dom';
import { WidgetContainer } from '../../infrastructure/widgets/WidgetContainer';
import { usePendingTasks } from './hooks/usePendingTasks';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { ROUTES } from '@/routes/paths';

export const pendingTasksConfig: WidgetConfig = {
  id: 'dash-pending-tasks',
  title: 'Pending Tasks',
  category: 'list',
  refreshStrategy: 'interval',
  defaultSize: { w: 4, h: 4 },
  priority: 2,
};

export function PendingTasksWidget() {
  const navigate = useNavigate();
  const { data, isLoading, isError, error, refetch } = usePendingTasks();

  const pendingTasks = data?.tasks?.filter(t => t.status !== 'done').slice(0, 5) || [];

  return (
    <WidgetContainer
      config={pendingTasksConfig}
      isLoading={isLoading}
      isError={isError}
      errorMessage={error?.message}
      onRefresh={() => { refetch(); }}
    >
      <div className="flex flex-col gap-2">
        {pendingTasks.length > 0 ? (
          pendingTasks.map((task) => (
            <div
              key={task.id || task._id}
              className="flex cursor-pointer items-center justify-between rounded-card-sm border border-outline bg-surface p-3 transition-colors hover:border-primary/40 hover:bg-surface-variant"
              onClick={() => navigate(ROUTES.tasks)}
            >
              <div className="flex-1 pr-2 overflow-hidden">
                <p className="text-[12px] font-semibold text-on-surface truncate">
                  {task.title}
                </p>
                <p className="text-[10px] text-on-surface-variant mt-0.5">
                  {task.due_date ? `Due ${task.due_date}` : 'No due date'}
                </p>
              </div>
              <span className="text-[10px] uppercase font-bold text-primary bg-primary/10 px-2 py-1 rounded whitespace-nowrap">
                {task.status.replace('_', ' ')}
              </span>
            </div>
          ))
        ) : (
          <p className="text-body-sm text-on-surface-variant italic p-4 text-center">
            No pending tasks.
          </p>
        )}
      </div>
    </WidgetContainer>
  );
}
